var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("oaFromBox", {
        attrs: {
          treeData: _vm.treeData,
          search: _vm.search,
          isTotal: false,
          isAddBtn: false,
          isViewSearch: false,
          sortSearch: false,
        },
        on: { treeChange: _vm.handType, confirmData: _vm.confirmData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }